// import axios from 'axios';

import Api from '@/api/config.ts';
import { apiUrls } from '@/api/api-urls.ts';
import {
  CreateTextMessageRequest,
  DialogMessages,
  DialogsResponse,
  GetDialogMessagesParams,
  GetDialogsParams,
  Message
} from '@/api/messaging/types.ts';

const getDialogs = async ({
  limit = 10,
  nextPageToken
}: GetDialogsParams): Promise<DialogsResponse> => {
  const response = await Api.get<DialogsResponse>(
    apiUrls.messaging.listDialogs,
    {
      params: {
        page_size: limit,
        ...(nextPageToken ? { page_token: nextPageToken } : {})
      }
    }
  );

  return response.data;
};

// Unmatch action
const deleteDialog = async (id: string) => {
  const response = await Api.delete<unknown>(
    apiUrls.messaging.deleteDialog(id)
  );

  return response.data;
};

const getDialogMessages = async (
  id: string,
  { limit = 25, nextPageToken }: GetDialogMessagesParams
): Promise<DialogMessages> => {
  const response = await Api.get<DialogMessages>(
    apiUrls.messaging.getDialogMessages(id),
    {
      params: {
        page_size: limit,
        ...(nextPageToken ? { page_token: nextPageToken } : {})
      }
    }
  );

  return response.data;
};

const createTextMessage = async (
  id: string,
  payload: CreateTextMessageRequest
) => {
  // return new Promise<never>((_, reject) => {
  //   setTimeout(() => {
  //     reject(
  //       new axios.AxiosError(
  //         'Bad Request',
  //         'ERR_BAD_REQUEST',
  //         undefined,
  //         undefined,
  //         {
  //           status: 400,
  //           statusText: 'Bad Request',
  //           data: { message: 'Text field is required' },
  //           config: {} as any,
  //           headers: {}
  //         }
  //       )
  //     );
  //   }, 3000);
  // });

  const response = await Api.post<{ message: Message }>(
    apiUrls.messaging.createTextMessage(id),
    payload
  );

  return response.data.message;
  // return {} as Message;
};

const readAllMessages = async (id: string) => {
  const response = await Api.post<unknown>(apiUrls.messaging.readMessages(id));

  return response.data;
};

const sendGift = async (id: string, payload: CreateTextMessageRequest) => {
  await Api.post<unknown>(apiUrls.messaging.sendGift(id), payload);
};

const acceptGift = async (id: string) => {
  await Api.post<unknown>(apiUrls.messaging.acceptGift(id));
};

const declineGift = async (id: string) => {
  await Api.post<unknown>(apiUrls.messaging.declineGift(id));
};

const MessagingController = {
  getDialogs,
  deleteDialog,
  getDialogMessages,
  createTextMessage,
  readAllMessages,
  sendGift,
  acceptGift,
  declineGift
};

export default MessagingController;